<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col sm="12">
                <c-table
                @page_changed="updateTableDataWithPage"
                @per_page_changed="updateTableDataWithPerPage"
                @delete_item="deleteTrack"
                @delete_items="deleteTracks"
                @edit_item="editTrack"
                @create_item="createTrack"
                @reset_validation="resetValidation"
                hover
                striped
                bordered
                small
                caption="Tracks"
                :tableData="tableData"
                :fields="fields"
                :loadStatus="loadStatus"
                :submitStatus="submitStatus"
                :message="message"
                :validation="validation"
                :key="tableDOM"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import cTable from './Table.vue'
import TrackAPI from '../../../../api/track.js'
export default {
    name      : 'Tracks',
    components: { cTable },
    data: function () {
        return {
            tableData: {},
            fields: [
                { key: 'checkbox', label: ' ' },
                { key: 'id', label: 'ID' },
                { key: 'original_title', label: 'Title' },
                { key: 'album', label: 'Album' },
                { key: 'compressed_file_path', label: 'File' },
                { key: 'track_no', label: 'Track no.' },
                { key: 'duration' },
                { key: 'created_at', label: 'Date added' },
                { key: 'actions' }
            ],
            loadStatus: 0,
            submitStatus: 2,
            message: '',
            validation: null,
            tableDOM: 0
        }
    },
    methods: {
        resetValidation() {
            this.$nextTick(() => { this.validation = null })
        },
        updateTableDataWithPage(newPage, perPage) {
            this.getTracks(newPage, perPage)
        },
        updateTableDataWithPerPage(perPage) {
            this.getTracks(1, perPage)
        },
        deleteTracks(trackIdsSeq, currentPage, perPage) {
            var vm = this
            vm.submitStatus = 1
            TrackAPI.deleteTracks(trackIdsSeq)
            .then(response => {
                vm.submitStatus = 2
                vm.getTracks(currentPage, perPage)
                vm.$snotify.success("Deleted successfully")
            })
            .catch(error => {
                vm.submitStatus = 3
                // Return back loadStatus value
                if (vm.tableData) {
                    vm.loadStatus = 2
                } else {
                    vm.loadStatus = 3
                }
                if (error && error.response) {
                    let msg = error.response.data.error ? error.response.data.error.message : error.response.data.message;
                    vm.$snotify.error("Failed to delete selected track(s): " + msg)
                } else {
                    vm.$snotify.error("Network error")
                }
            })
        },
        deleteTrack(trackId, currentPage, perPage) {
            var vm = this
            vm.submitStatus = 1
            TrackAPI.deleteTrack(trackId)
            .then(response => {
                vm.submitStatus = 2
                vm.getTracks(currentPage, perPage)
                vm.$snotify.success("Deleted successfully")
            })
            .catch(error => {
                vm.submitStatus = 3
                // Return back loadStatus value
                if (vm.tableData) {
                    vm.loadStatus = 2
                } else {
                    vm.loadStatus = 3
                }
                if (error && error.response) {
                    let msg = error.response.data.error ? error.response.data.error.message : error.response.data.message;
                    vm.$snotify.error("Failed to delete this track: " + msg)
                } else {
                    vm.$snotify.error("Network error")
                }
            })
        },
        getTracks(page = 1, perPage = 15) {
            var vm = this
            vm.loadStatus = 1
            TrackAPI.getTracks(page, perPage)
            .then(response => {
                vm.tableData = response.data.tracks
                vm.loadStatus = 2
            })
            .catch(error => {
                vm.loadStatus = 3
            })
        },
        editTrack(trackItem, currentPage, perPage) {
            var vm = this
            vm.submitStatus = 1
            TrackAPI.editTrack(trackItem.id, trackItem.original_title, trackItem.romaji_title, trackItem.english_title, trackItem.original_file_path, trackItem.track_no, trackItem.lyrics, trackItem.duration, trackItem.album_id)
            .then(response => {
                vm.submitStatus = 2
                vm.getTracks(currentPage, perPage)
                vm.$snotify.success("Edited successfully")
            })
            .catch(error => {
                vm.submitStatus = 3
                // Return back loadStatus value
                if (vm.tableData) {
                    vm.loadStatus = 2
                } else {
                    vm.loadStatus = 3
                }
                if (error && error.response) {
                    vm.validation = error.response.data.validation;
                    let msg = error.response.data.error ? error.response.data.error.message : error.response.data.message;
                    vm.$snotify.error("Failed to edit this track: " + msg)
                } else {
                    vm.$snotify.error("Network error")
                }
            })
        },
        createTrack(trackItem, currentPage, perPage) {
            var vm = this
            vm.submitStatus = 1
            TrackAPI.createTrack(trackItem.original_title, trackItem.romaji_title, trackItem.english_title, trackItem.original_file_path, trackItem.track_no, trackItem.lyrics, trackItem.duration, trackItem.album_id)
            .then(response => {
                vm.submitStatus = 2
                vm.getTracks(currentPage, perPage)
                vm.$snotify.success("Created successfully")
            })
            .catch(error => {
                vm.submitStatus = 3
                // Return back loadStatus value
                if (vm.tableData) {
                    vm.loadStatus = 2
                } else {
                    vm.loadStatus = 3
                }
                if (error && error.response) {
                    vm.validation = error.response.data.validation;
                    let msg = error.response.data.error ? error.response.data.error.message : error.response.data.message;
                    vm.$snotify.error("Failed to create this track: " + msg)
                } else {
                    vm.$snotify.error("Network error")
                }
            })
        }
    },
    created () {
        let perPage = window.localStorage.getItem('per_page') || 15
        this.getTracks(1, perPage)
    },
}
</script>
